module.exports = __webpack_public_path__ + "img/ps-48.d227880a.jpg";